import { AddCommentAmountExpenseReport } from "../../../domain/useages/expense-dashboard/add-comment-amount-expense-report";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpPutClient } from "../../protocols/http/http-put-client";


export class RemoteAddCommentAmountExpenseReport implements AddCommentAmountExpenseReport {
  constructor(
    private readonly url: string,
    private readonly httpPutClient: HttpPutClient
  ) {}

  async update(payload: AddCommentAmountExpenseReport.Params): Promise<any> {
    const httpResponse = await this.httpPutClient.put({
      url: this.url,
      body: payload,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    if (httpResponse.status === 200) {
      return httpResponse.data;
    }
  }
}
